import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import { BookingProvider } from "@/context/BookingContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminContent from "@/pages/AdminContent";
import HarKiDun from "@/pages/HarKiDun";
import Kedarkantha from "@/pages/Kedarkantha";

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname !== "/") return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchorClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href");
      if (!id || id === "#") return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onAnchorClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
    };
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route
          path="/"
          element={
            <ContentProvider>
              <BookingProvider>
                <Landing />
              </BookingProvider>
            </ContentProvider>
          }
        />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/content" element={<AdminContent />} />
        <Route
          path="/trek/har-ki-dun"
          element={
            <ContentProvider>
              <BookingProvider>
                <HarKiDun />
              </BookingProvider>
            </ContentProvider>
          }
        />
        <Route
          path="/trek/kedarkantha"
          element={
            <ContentProvider>
              <BookingProvider>
                <Kedarkantha />
              </BookingProvider>
            </ContentProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
